<template>
  <footer class="footer d-flex flex-column flex-md-row align-items-center justify-content-between bottom-0 w-full">
    <p class="text-muted text-center text-md-left ml-7">
      Copyright © 2021 VENTENY All rights reserved
    </p>
    <p class="text-muted text-center text-md-left mr-7">
      Version: {{ packageVersion }}
    </p>
  </footer>
</template>

<script>
import { version } from '../../../package.json';

export default {
  name: 'Footer',
  data() {
    return {
      packageVersion: version,
    };
  },
};
</script>
